<template>
  <v-container
    class="my-6"
  >
    <v-row
      align="start"
      justify="center"
      class="text-center mb-1"
    >
      <v-col>
        <v-icon x-large>
          supervisor_account
        </v-icon>
        <h2 class="display-2">
          Deine Mannschaft
        </h2>
      </v-col>
    </v-row>

    <v-row class="my-6 d-none d-sm-flex">
      <v-col class="text-center">
        <v-btn-toggle
          v-model="toggleActive"
          rounded
          background-color="primary darken-1"
          dark
        >
          <v-btn>
            Übersicht
          </v-btn>
          <v-btn to="/aufstellung">
            Aufstellung
          </v-btn>
          <v-btn to="/training">
            Training / Trainingslager
          </v-btn>
          <v-btn to="/vertrag">
            Verträge
          </v-btn>
        </v-btn-toggle>
      </v-col>
    </v-row>

    <page-loading :is-page-loading="$store.state.pageLoading" />

    <v-row
      justify="space-around"
      align="center"
    >
      <v-col cols="12" sm="6">
        <v-card>
          <v-card-title
            class="primary darken-2 white--text"
          >
            Dein Team
          </v-card-title>
          <v-divider />
          <v-card-text>
            <v-row
              justify="center"
              align="center"
            >
              <v-col cols="5" class="text-center">
                <v-avatar
                  size="92px"
                  tile
                >
                  <v-img :src="$store.state.teamStore.team.logo" />
                </v-avatar>
              </v-col>
              <v-col
                class="headline"
              >
                {{ $store.state.teamStore.team.name }}
              </v-col>
            </v-row>
            <v-divider class="my-4" />
            <v-row class="title">
              <v-col cols="5" class="py-1 text-left text-sm-right">
                Liga:
              </v-col>
              <v-col cols="7" class="py-1">
                {{ $store.state.teamStore.team.liga }}
              </v-col>
              <v-col cols="5" class="py-1 text-left text-sm-right">
                Wurfzahl:
              </v-col>
              <v-col cols="7" class="py-1">
                {{ $store.state.teamStore.team.wurfzahl }} Wurf
              </v-col>
              <v-col cols="5" class="py-1 text-left text-sm-right">
                Heimrekord:
              </v-col>
              <v-col cols="7" class="py-1">
                {{ $store.state.office.heimRekord }} Holz
              </v-col>
              <v-col cols="5" class="py-1 text-left text-sm-right">
                Auswärtsrekord:
              </v-col>
              <v-col cols="7" class="py-1">
                {{ $store.state.office.auswRekord }} Holz
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <players
      :players="$store.state.teamStore.players | sortByPosition"
    />

    <v-row class="my-6">
      <v-col class="text-center">
        <v-btn-toggle
          v-model="toggleActive"
          rounded
          background-color="primary darken-1"
          dark
        >
          <v-btn>
            Übersicht
          </v-btn>
          <v-btn to="/aufstellung">
            Aufstellung
          </v-btn>
          <v-btn to="/training">
            Training / Trainingslager
          </v-btn>
          <v-btn to="/vertrag">
            Verträge
          </v-btn>
        </v-btn-toggle>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'Mannschaft',
  metaInfo: {
    title: 'Mannschaft'
  },
  data () {
    return {
      tableView: false,
      icon: 'column',
      toggleActive: 0
    }
  },
  mounted: async function () {
    // lade alle spieler / mannschaft
    // mannschaftsstatistik
  },
  watch: {

  },
  methods: {

  }
}
</script>
